<section>
  <yo-survey-rating
    *ngIf="step === 'RATING'"
    [title]="videoSurveyRatingCtx.title"
    [description]="videoSurveyRatingCtx.description"
    [numberOfOptions]="5"
    [minLabel]="videoSurveyRatingCtx.minLabel"
    [maxLabel]="videoSurveyRatingCtx.maxLabel"
    optionType="STAR"
    (onClose)="saveStreamFeedback(ratingValue)"
    (onSubmit)="submitRating($event)"
  >
  </yo-survey-rating>
  <yo-survey-feedback
    *ngIf="step === 'FEEDBACK'"
    [title]="
      rating && rating > 3
        ? videoSurveyFeedbackCtx.positiveTitle
        : videoSurveyFeedbackCtx.constructiveTitle
    "
    [submitLabel]="videoSurveyFeedbackCtx.submitLabel"
    (onClose)="saveStreamFeedback(ratingValue)"
    (onSubmit)="saveStreamFeedback(ratingValue, $event)"
  >
    <p
      yo-survey-feedback-footer
      *ngIf="rating !== undefined && rating !== null"
      class="flex flex-2 flex-align-center gap-2"
    >
      <span class="text-xs m-t-4" i18n="@@videoSurveyFeedbackFooter">
        You rated {{ rating }}
      </span>
      <yo-icon icon="star_solid" size="md" [themed]="true"></yo-icon>
    </p>
  </yo-survey-feedback>
</section>
